export default function Landing({ onLogin, onSignup }) {
  return (
    <div style={s.screen}>
      <div style={s.content}>

        <img src='/crossbet-logo.png' alt='Crossbet' style={{ width: 120, height: 120, objectFit: 'contain' }} />

        <div style={s.wordmark}>CROSSBET</div>
        <div style={s.tagline}>SOCIAL BETTING APP</div>
        <div style={s.divider} />

        <div style={s.buttons}>
          <button style={s.primaryBtn} onClick={onSignup}>Create Account</button>
          <button style={s.secondaryBtn} onClick={onLogin}>Log In</button>
        </div>

        <div style={s.footer}>Alpha Version · By invite only</div>
      </div>
    </div>
  )
}

const s = {
  screen: { minHeight: '100vh', background: '#00563F', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Outfit', 'DM Sans', sans-serif" },
  content: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, padding: '0 32px', width: '100%', maxWidth: 360 },
  wordmark: { fontFamily: "'Outfit', sans-serif", fontSize: 44, fontWeight: 800, color: '#FDF9E7', letterSpacing: 6, lineHeight: 1, marginTop: 8 },
  tagline: { fontSize: 11, fontWeight: 500, color: 'rgba(253,249,231,0.5)', letterSpacing: 3 },
  divider: { width: 40, height: 1, background: 'rgba(193,154,107,0.4)', margin: '8px 0' },
  buttons: { display: 'flex', flexDirection: 'column', gap: 12, width: '100%', marginTop: 8 },
  primaryBtn: { width: '100%', background: '#C19A6B', border: 'none', borderRadius: 14, padding: '16px', fontSize: 16, fontWeight: 700, color: '#0A0A0A', cursor: 'pointer', fontFamily: 'inherit', letterSpacing: 0.5 },
  secondaryBtn: { width: '100%', background: 'transparent', border: '1.5px solid rgba(253,249,231,0.3)', borderRadius: 14, padding: '16px', fontSize: 16, fontWeight: 600, color: '#FDF9E7', cursor: 'pointer', fontFamily: 'inherit', letterSpacing: 0.5 },
  footer: { fontSize: 11, color: 'rgba(253,249,231,0.3)', marginTop: 24, letterSpacing: 1 },
}
